import React, { useState } from 'react'
import Table from 'UI/Table'
import { columns } from './Columns'
import VulnerabilitiesModal from './VulnerabilitiesModal';
import { find, get, map, reverse } from 'lodash';
import { ProgressBar } from 'react-bootstrap';
import { severityColor } from './Helper';

const IPAssetVulnerabilitiesTable = ({ hostsData }) => {
  const [showID, setShowID] = useState(false);
  const tableColumns = [
    ...columns,
    {
      Header: 'Vulnerabilities',
      accessor: 'vulnerabilities_score',
      Cell: row => (
        <div className='cursor-pointer hover:bg-gray-100' onClick={() => setShowID(row.original.id)}>
          {row.original.in_shodan ? (
            <ProgressBar className='cursor-pointer'>
              {map(reverse(Object.entries(row.original.vulnerabilities)), ([severity, vulnerabilitiesArray]) => (
                <ProgressBar style={{ backgroundColor: severityColor(severity) }} now={(vulnerabilitiesArray.length / row.original.vulnerabilities_count)*100} />
              ))}
            </ProgressBar>
          ) : <ProgressBar now={100} />}

        </div>
      )
    }
  ]
  const currentHost = showID ? find(hostsData, ['id', showID]) : {}

  return (
    <div>
      <div className="d-flex mb-2 justify-content-end">
        <a href='/vulnerabilities/globe'>
          View on Globe
        </a>
      </div>

      <Table columns={tableColumns} data={hostsData} filterable tableProps={{ defaultSorted: [{ id: 'vulnerabilities_score', desc: true }] }} />

      <VulnerabilitiesModal
        show={showID}
        setShow={() => setShowID(false)}
        vulnerabilities={currentHost?.vulnerabilities}
        vulnerabilitiesCount={currentHost?.vulnerabilities_count}
        deviceIP={currentHost?.ip_address}
      />
    </div>
  )
}

export default IPAssetVulnerabilitiesTable
